// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3OFRw","subheader":"ReorderModal_subheader__7nX4X","listWrap":"ReorderModal_listWrap__3m_zg"};